import React from 'react';
import ReactSlick from 'react-slick';
import Cta from '../../subcomponents/Cta';
import ArrowSvg from '../../icons/ArrowSvg';
import SmartImage from '../../subcomponents/SmartImage';
import findAltText from '../../utils';

import './gallery.scss';

class Gallery extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      activeSlide: 0,
      ctaContent: props.ctaContent,
    };
  }

  render() {
    // Define the props to be received
    const { campaignType, order, version } = this.props;
    const {
    cta, 
    svgArrowColor, 
    numberOfImages, 
    noBackground, 
    backgroundColor,
    useGradient, 
    backgroundGradient,
    gradientDirection, 
    hide, 
    hideCta,
    type, 
    imageType, 
    galleryNumber, 
    anchorName, 
    roundedCorners, 
    removeArrow,
    } = this.props.element;
    const { slug, imagePattern } = this.props.url;
    const translations = window.campaign_data.campaign_translations.blocks;
    const commonTranslations = window.campaign_data.common_translations.blocks;
    const roundTheCorners = (campaignType === 'general' && roundedCorners) ? 'rounded-corners' : '';

    // slick slider arrows
    const PrevArrow = ({ className, onClick }) => {
      return (
        <div className={`${className} arrowLeft arrowSlider`} aria-label="Previous Slide" onClick={onClick} role="button" tabIndex="0">
            <ArrowSvg svgColor={svgArrowColor} />
        </div>
      );
    };
    const NextArrow = ({ className, onClick }) => {
      return (
        <div className={`${className} arrowRight arrowSlider`} aria-label="Next Slide" onClick={onClick} role="button" tabIndex="0">
            <ArrowSvg svgColor={svgArrowColor} />
        </div>
      );
    };

    const params = {
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: true,
      arrows: true,
      prevArrow: <PrevArrow />,
      nextArrow: <NextArrow />,
      infinite: true,
      lazyLoad: true,
      touchThreshold: 15,
      speed: 300,
      beforeChange: (current, next) => this.setState({ activeSlide: next }),
    };

    let ctaText = commonTranslations.shopnow;
    if (campaignType === 'sale' && translations[`${this.state.ctaContent}ctatext`]) ctaText = translations[`${this.state.ctaContent}ctatext`];
    if (campaignType === 'general' && translations[`gallery${galleryNumber}ctatext`]) ctaText = translations[`gallery${galleryNumber}ctatext`];

    // gallery section classes based on campaign type
    let sectionClasses = ['component', 'gallery-section'];
    switch (campaignType) {
      case 'sale':
        sectionClasses = [...sectionClasses];
        break;
      case 'general':
        sectionClasses = [...sectionClasses];
        break;
      case 'boots':
        if (noBackground) sectionClasses.push('smart-section');
        break;
      default:
        if (noBackground) sectionClasses.push('smart-section');
        break;
    }
    let styler = {};
     if (noBackground && useGradient && gradientDirection === 'leftToRight') {
       styler = { background: `linear-gradient(to right, ${backgroundColor} 0%, ${backgroundGradient} 100%)` };
    } else if (noBackground && useGradient && gradientDirection === 'topToBottom') {
       styler = { background: `linear-gradient(${backgroundColor} 0%, ${backgroundGradient} 100%)` };
    } else if (noBackground && !useGradient) {
       styler = { background: backgroundColor };
    } else {
       styler = {};
    }
    let component = null;
    if (!hide) {
      component = (
        <section
          id={anchorName || ''}
          className={sectionClasses.join(' ')}
          style={styler}
          dataorder={order}
          datatype={type}
        >
          {!noBackground && campaignType !== 'sale' &&
            <SmartImage
              slug={slug}
              name={campaignType !== 'general' ? `110-gallery${imagePattern}` : `110-gallery${galleryNumber}${imagePattern}`}
              version={version}
              campaignType={campaignType}
              className={campaignType === 'general' ? 'heightBackground' : ''}
              alt={findAltText(`Gallery Background ${galleryNumber}`)}
            />
          }
          <div className={campaignType === 'sale' || (campaignType === 'general' && noBackground) ? 'mainWidth sale' : 'mainWidth'}>
            <div className="gallery">
            <div className="galleryPagination">
              <span>{this.state.activeSlide + 1}</span>
              /
              <span>{numberOfImages}</span>
            </div>
            <ReactSlick {...params}>
            { new Array(Number(numberOfImages)).fill('.')
                    .map((el, i) => (
                      <div key={`g${i + 1}`}>
                        {window.innerWidth < 767 ?
                          <img
                            style={{ width: '100%' }}
                            src={`${slug}gallery${campaignType === 'general' ? galleryNumber : ''}/mobile/0${i + 1}${imageType || '.jpg'}?version=${version}`}
                            alt={findAltText(`Gallery Image ${i + 1} ${galleryNumber}`)}
                            className="gallerySlide"
                          />
                          :
                          <img
                            style={{ width: '100%' }}
                            src={`${slug}gallery${campaignType === 'general' ? galleryNumber : ''}/desktop/0${i + 1}${imageType || '.jpg'}?version=${version}`}
                            alt={findAltText(`Gallery Image ${i + 1} ${galleryNumber}`)}
                            className="gallerySlide"
                          />
                        }
                      </div>
                    ))}
            </ReactSlick>
              {!this.props.isBootroom && !hideCta &&
                <Cta
                  className={`gallery-cta ${roundTheCorners}`}
                  url={campaignType !== 'general' ? translations.linkcategory : translations[`gallery${galleryNumber}link`]}
                  translation={ctaText}
                  backgroundColor={cta.ctaBackgroundColor}
                  textColor={cta.ctaTextColor}
                  ctaArrowColor={cta.ctaArrowColor}
                  borderColor={cta.ctaBorderColor}
                  noArrow={removeArrow}
                  campaignType={campaignType}
                />
              }
            </div>
          </div>
        </section>
      );
    }
    return (
      <React.Fragment>
        { component }
      </React.Fragment>
    );
  }
}

export default Gallery;
